import React, { Fragment, memo } from 'react';
import { getImageUrl } from 'services/client/cloudflare/getImageUrl';
import { getEventLocation } from 'utils/shared/location/getEventLocation';
import CloseIcon from 'svg/CloseIcon';
import TournamentIcon from 'svg/Tournament';
import { ButtonText } from 'components/Button';
import classNames from 'styles/utils/classNames';
import TournamentCard from './TournamentCard';
import { TournamentMapMarkerProps } from './props';

const MemoizedTournamentIcon = memo(TournamentIcon);
const MemoizedTournamentCard = memo(TournamentCard);

const TournamentMapMarker: React.FC<TournamentMapMarkerProps> = ({
  listHoveredTournamentId,
  setListHoveredTournamentId,
  setActiveTournamentId,
  activeTournament,
  tournament,
}) => {
  const isActive = activeTournament?.id === tournament.id;
  const isHovered = listHoveredTournamentId === tournament.id;

  return (
    <Fragment>
      <div
        onClick={() => setActiveTournamentId(tournament.id)}
        onMouseLeave={() => setListHoveredTournamentId(null)}
        onMouseEnter={() => setListHoveredTournamentId(tournament.id)}
        className={classNames(
          'group relative flex h-8 w-8 cursor-pointer items-center justify-center rounded-full shadow-[0px_4px_4px_0px_rgba(0,0,0,0.16)] transition-[background-color]',
          isHovered || isActive
            ? 'z-20 bg-color-bg-lightmode-brand text-color-text-lightmode-invert dark:bg-color-bg-lightmode-brand dark:text-color-text-lightmode-invert'
            : 'bg-color-bg-lightmode-primary text-color-text-lightmode-secondary dark:bg-color-bg-darkmode-primary dark:text-color-text-darkmode-secondary',
        )}
      >
        <MemoizedTournamentIcon className="h-4 w-4" />
      </div>
      {isActive && (
        <div className="absolute left-7 top-1/2 isolate z-60 ml-4  flex w-[20rem] -translate-y-1/2 transform justify-center rounded-t-xl bg-color-bg-lightmode-primary p-ds-lg dark:bg-color-bg-darkmode-primary">
          <div className="absolute right-6 top-6 z-10 flex items-center justify-center rounded-full bg-color-bg-lightmode-invert bg-opacity-50">
            <ButtonText
              onClick={() => setActiveTournamentId(null)}
              className="flex items-center justify-center rounded-full p-2"
            >
              <CloseIcon className="h-6 w-6 text-color-text-lightmode-invert" />
            </ButtonText>
          </div>
          <MemoizedTournamentCard
            tournamentId={tournament.id}
            coverImageUrl={
              tournament.coverImagePath
                ? getImageUrl({
                    url: `${process.env.CLOUDFLARE_PUBLIC_URL}${tournament.coverImagePath}`,
                    path: tournament.coverImagePath,
                  })
                : ''
            }
            organizerImageUrl={
              tournament.organizerImagePath
                ? getImageUrl({
                    url: `${process.env.CLOUDFLARE_PUBLIC_URL}${tournament.organizerImagePath}`,
                    path: tournament.organizerImagePath,
                  })
                : ''
            }
            title={tournament.title}
            registrationClosedAt={tournament.registrationClosedAt}
            startTimestamp={tournament.startTimestamp}
            status={tournament.status}
            sourceOrganizerTitle={tournament.sourceOrganizerTitle}
            sourceRegistrationCount={tournament.sourceRegistrationCount}
            registrationCount={tournament.registrationsAggregate?.aggregate?.count || 0}
            isExternal={tournament.isExternal}
            isVairRequired={tournament.isVairRequired ?? false}
            displayDate={tournament.displayDate}
            displayLocation={getEventLocation(tournament)}
            distance={tournament.distance}
            showImageAndPeople={true}
          />
        </div>
      )}
    </Fragment>
  );
};

export default TournamentMapMarker;
